var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "mb-6 flex flex-wrap items-center justify-between gap-4",
        },
        [
          _c("FinancialPeriodFilter", {
            on: { change: _vm.handleFilterChange },
            model: {
              value: _vm.filters,
              callback: function ($$v) {
                _vm.filters = $$v
              },
              expression: "filters",
            },
          }),
          _vm.filters.institution_id
            ? _c(
                "vs-button",
                {
                  attrs: {
                    "icon-pack": "feather",
                    icon: "icon-external-link",
                    disabled: _vm.openingStripeDashboard,
                  },
                  on: { click: _vm.openStripeDashboard },
                },
                [_vm._v(" Abrir painel do Stripe ")]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm.loading
        ? _c(
            "div",
            { staticClass: "text-center py-8" },
            [
              _c(
                "vs-button",
                {
                  staticClass: "mb-2",
                  attrs: { type: "border", disabled: true },
                },
                [
                  _c("span", { staticClass: "animate-spin" }, [
                    _vm._v("Carregando..."),
                  ]),
                ]
              ),
            ],
            1
          )
        : [
            _c(
              "div",
              {
                staticClass:
                  "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 mb-6",
              },
              [
                _c("DashboardStatisticsCard", {
                  attrs: {
                    title: "Total de Receita",
                    value: _vm.dashboardData.total_revenue,
                    description: "Receita total confirmada",
                    type: "primary",
                    icon: "DollarSignIcon",
                    "icon-color": "success",
                    "value-size": "large",
                    formatter: _vm.formatCurrency,
                  },
                }),
                _c("DashboardStatisticsCard", {
                  attrs: {
                    title: "Taxas da Plataforma",
                    value: _vm.dashboardData.platform_fees,
                    description:
                      "Receita líquida = bruta − taxas da plataforma",
                    type: "info",
                    icon: "PercentIcon",
                    "value-size": "small",
                    formatter: _vm.formatCurrency,
                  },
                }),
                _c("DashboardStatisticsCard", {
                  attrs: {
                    title: "Ticket Médio",
                    value: _vm.dashboardData.avg_order_value,
                    description: "Valor médio por pedido",
                    type: "info",
                    icon: "TrendingUpIcon",
                    "value-size": "small",
                    formatter: _vm.formatCurrency,
                  },
                }),
                _c("DashboardStatisticsCard", {
                  attrs: {
                    title: "Receita Pendente",
                    value: _vm.dashboardData.pending_revenue,
                    description: "Aguardando confirmação",
                    type: "warning",
                    icon: "ClockIcon",
                    "value-size": "small",
                    formatter: _vm.formatCurrency,
                  },
                }),
                _c("DashboardStatisticsCard", {
                  attrs: {
                    title: "Total de Pedidos",
                    value: _vm.dashboardData.total_orders,
                    description: "Pedidos realizados",
                    type: "primary",
                    icon: "ShoppingBagIcon",
                    "value-size": "large",
                  },
                }),
                _c("DashboardStatisticsCard", {
                  attrs: {
                    title: "Pagamentos Pendentes",
                    value: _vm.dashboardData.pending_payment_count,
                    description: "Aguardando processamento",
                    type: "warning",
                    icon: "AlertCircleIcon",
                    "value-size": "large",
                  },
                }),
                _c("DashboardStatisticsCard", {
                  attrs: {
                    title: "Pagamentos Pagos",
                    value: _vm.dashboardData.paid_payment_count,
                    description: "Pagamentos confirmados",
                    type: "success",
                    icon: "CheckCircleIcon",
                    "value-size": "large",
                  },
                }),
                _c("DashboardStatisticsCard", {
                  attrs: {
                    title: "Pagamentos Recusados",
                    value: _vm.dashboardData.refused_payment_count,
                    description: "Pagamentos recusados",
                    type: "danger",
                    icon: "XCircleIcon",
                    "value-size": "large",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6" },
              [
                _c(
                  "vx-card",
                  [
                    _c("template", { slot: "no-body" }, [
                      _c(
                        "div",
                        { staticClass: "p-6" },
                        [
                          _c(
                            "h3",
                            { staticClass: "mb-4 font-semibold text-lg" },
                            [_vm._v("Status de Pagamentos")]
                          ),
                          _vm.dashboardData &&
                          _vm.paymentStatusSeries &&
                          _vm.paymentStatusSeries.length > 0
                            ? _c("vue-apex-charts", {
                                attrs: {
                                  type: "donut",
                                  height: "350",
                                  options: _vm.paymentStatusChartOptions,
                                  series: _vm.paymentStatusSeries,
                                },
                              })
                            : _c(
                                "div",
                                {
                                  staticClass:
                                    "flex items-center justify-center h-64 text-gray-500",
                                },
                                [_vm._v(" Nenhum dado disponível ")]
                              ),
                        ],
                        1
                      ),
                    ]),
                  ],
                  2
                ),
                _c(
                  "vx-card",
                  [
                    _c("template", { slot: "no-body" }, [
                      _c(
                        "div",
                        { staticClass: "p-6" },
                        [
                          _c(
                            "h3",
                            { staticClass: "mb-4 font-semibold text-lg" },
                            [_vm._v("Comparação de Receita")]
                          ),
                          _c("vue-apex-charts", {
                            attrs: {
                              type: "bar",
                              height: "350",
                              options: _vm.revenueChartOptions,
                              series: _vm.revenueSeries,
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ],
                  2
                ),
              ],
              1
            ),
            _c(
              "vx-card",
              [
                _c("template", { slot: "no-body" }, [
                  _c(
                    "div",
                    { staticClass: "p-6" },
                    [
                      _c("h3", { staticClass: "mb-4 font-semibold text-lg" }, [
                        _vm._v(" Top 3 Produtos Mais Vendidos "),
                      ]),
                      _c("vue-apex-charts", {
                        attrs: {
                          type: "bar",
                          height: "350",
                          options: _vm.topProductsChartOptions,
                          series: _vm.topProductsSeries,
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ],
              2
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }